import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Dropdown } from 'semantic-ui-react';
import Policy from '../policy';
import PastPaymentList from './PastPaymentList';
import { policyIcon } from '../../../helpers/policy';

const PastPaymentInformation = ({ items, selectedPolicy, onListItemClick }) => {
	const policyListItems = items.map((policy, index) => {
		return <Policy.ListItem key={index} icon={policyIcon(policy.policyNumber)} nickName={policy.nickname} policyNumber={policy.policyNumber} type={policy.type} status={policy.status} onClick={onListItemClick} data={policy} active={selectedPolicy.policyNumber === policy.policyNumber} effective={policy.effective} expiration={policy.expiration} />;
	});
	const policies = items.map((policy) => {
		return { text: `${policy.nickname} (${policy.policyNumber})`, value: policy.policyNumber, data: policy };
	});
	const onChange = (e, item) => {
		const policy = items.find((p) => p.policyNumber === item.value);
		onListItemClick(e, { data: policy });
	};

	return (
		<Grid className='payment_information'>
			<Grid.Column width='4' className='tablet only computer only'>
				<Policy.List>{policyListItems}</Policy.List>
			</Grid.Column>
			<Grid.Column className='left divider' mobile={16} computer={12} tablet={12}>
				<Dropdown className='mobile only' value={selectedPolicy.policyNumber} fluid selection options={policies} onChange={onChange} />
				{selectedPolicy && selectedPolicy.billing && <PastPaymentList items={selectedPolicy.billing.billingItems} />}
			</Grid.Column>
		</Grid>
	);
};

PastPaymentInformation.propTypes = {
	items: PropTypes.array,
	selectedPolicy: PropTypes.object.isRequired,
	onListItemClick: PropTypes.func.isRequired,
};

export default PastPaymentInformation;
